import classNames from 'classnames';
import { memo, ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  fluid?: 'fluid' | 'screen' | 'card';
  noFullWidth?: boolean;
  id?: string;
}

const Container = ({ children, fluid = 'card', noFullWidth = false, id }: ContainerProps) => {
  const classes = classNames('relative', {
    'w-full': !noFullWidth,
    'py-8': fluid === 'fluid',
    'px-3 lg:px-4 2xl:px-12': fluid === 'card',
    'px-[1.7%] py-6 2xl:px-[3%] 2xl:py-8': fluid === 'screen',
  });

  if (fluid === 'screen') {
    return (
      <div
        className="relative h-full w-full bg-emblueLightGray"
        data-testid="container-component"
        id={id}
      >
        <div className={classes}>{children}</div>
      </div>
    );
  }

  return <div className={classes}>{children}</div>;
};

export default memo(Container);
